export interface IResult {
  id: string;
  status: string;
  rate: string;
  rate_type: string;
}

export enum ResultEnum {
  OFFSET = 'Зачет',
  DISREGARD = 'Незачёт',
  OFFSET_TYPE = '1',
}



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/compopnents/block/components/result/types.ts